import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { HeroBackgroundComponent } from './background/background.component'
import { HeroComponent } from './hero.component'

@NgModule({
  declarations: [
    HeroBackgroundComponent,
    HeroComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    HeroComponent
  ]
})

export class HeroModule {}